import { render, staticRenderFns } from "./DoctorEditBankDetails.vue?vue&type=template&id=01866ff4&"
import script from "./DoctorEditBankDetails.vue?vue&type=script&lang=js&"
export * from "./DoctorEditBankDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports